"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const ArrowThin = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 12,
  viewBox: "0 0 16 12"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M6.71 11.705a.999.999 0 000-1.42l-3.3-3.287H15A1 1 0 1015 5H3.41l3.3-3.287A1.003 1.003 0 105.29.294l-5 4.996a1 1 0 00-.21.33.939.939 0 000 .759 1 1 0 00.21.33l5 4.996a1 1 0 001.42 0z",
  fillRule: "evenodd"
}));
var _default = exports.default = ArrowThin;